import { withProps } from 'recompose';

// Components
import SaveComponent from '../../../molecules/SaveComponent';
var mapFooterPropsToSaveProps = function mapFooterPropsToSaveProps(props) {
  return {
    onPrimaryAction: props.onSubmit,
    onSecondaryAction: props.onCancel,
    primaryActionLoading: props.primaryActionLoading,
    showSecondaryButton: props.showSecondaryButton,
    isPrimaryDisabled: props.isPrimaryDisabled
  };
};
var FooterComponent = withProps(mapFooterPropsToSaveProps)(SaveComponent);
export default FooterComponent;